export default __webpack_public_path__ + "static/media/noiz-isotype.0a977c9d.png";